import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Constant } from '@common/Constant';
import { ApplicationConfig } from '@config/ApplicationConfig';
import { map } from 'rxjs/operators';
import { ObjectUtil } from '@util/ObjectUtil';
import { SickLeaveDTO } from '@dto/sickLeave/SickLeaveDTO';

@Injectable({
  providedIn: 'root'
})
export class EventSickLeaveService {

  constructor(private http: HttpClient) {
  }

  public getList(eventId: number): Observable<SickLeaveDTO[]> {
    let headers: HttpHeaders = new HttpHeaders();

    headers = headers.set(Constant.HTTP_SILENT_MODE, '');

    return this.http.get(`${ ApplicationConfig.apiUrl }/events/${ eventId }/sick-leaves`, { headers })
      .pipe(
        map((response: any) => ObjectUtil.plainToClassArray(SickLeaveDTO, response))
      );
  }

  public create(eventId: number, sickLeave: SickLeaveDTO): Observable<SickLeaveDTO> {
    return this.http.post(`${ ApplicationConfig.apiUrl }/events/${ eventId }/sick-leaves`, ObjectUtil.classToPlain(sickLeave))
      .pipe(
        map((response: any) => ObjectUtil.plainToClass(SickLeaveDTO, response))
      );
  }

  public remove(eventId: number, sickLeaveId: number): Observable<unknown> {
    return this.http.delete(`${ ApplicationConfig.apiUrl }/events/${ eventId }/sick-leaves/${ sickLeaveId }`);
  }
}